var React = require('react');

function Saturn (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.186 4v2.08H9.015V8h2.171v14.56h1.92v-8.07c1.149-2.172 2.775-3.13 4.8-3.13.96 0 1.578.417 2.082 1.173.503.755.798 1.867.798 2.987 0 2.24-1.225 4.668-2.279 5.721-1.393 1.393-2.2 2.919-2.2 4.519 0 .96.509 1.733 1.08 2.19.57.457 1.16.69 1.8.69.64 0 1.134-.291 1.535-.593.402-.3.743-.648 1.063-.968l-1.358-1.358c-.32.32-.619.612-.857.79-.238.179-.384.209-.384.209s-.372-.086-.601-.27c-.23-.183-.359-.37-.359-.69 0-.96.472-1.994 1.639-3.161 1.506-1.506 2.841-4.199 2.841-7.079 0-1.44-.344-2.888-1.121-4.053-.777-1.164-2.079-2.027-3.679-2.027-1.8 0-3.466.665-4.8 1.906V8h3.589V6.08h-3.589V4h-1.92z"}));
}

Saturn.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Saturn;

Saturn.default = Saturn;
